import { render, staticRenderFns } from "./DraftsBox.vue?vue&type=template&id=6bf185a8&scoped=true&"
import script from "./DraftsBox.vue?vue&type=script&lang=js&"
export * from "./DraftsBox.vue?vue&type=script&lang=js&"
import style0 from "./DraftsBox.vue?vue&type=style&index=0&id=6bf185a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf185a8",
  null
  
)

export default component.exports